import React from 'react';

import HeaderSubcard from './header-subcard';
import ProductsSubcard from './products-subcard';
import EditSubcard from './edit-subcard';

import './orders-card.scss';

const Card = ({ data, loadingProducts }) => {
  const products = data.event_products;
  const showLoadingSpinner = loadingProducts && !products;

  return (
    <div className="orders-card">
      <HeaderSubcard data={data} />
      <div className="bottom-subcards">
        <ProductsSubcard data={data} showLoadingSpinner={showLoadingSpinner} />
        <EditSubcard data={data} />
      </div>
    </div>
  );
};

export default Card;
